/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Run_Start_In_PastInputs */

const vi_error_irrigation_run_start_in_past = /** @type {(inputs: Error_Irrigation_Run_Start_In_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ hẹn đã qua, chọn giờ trong tương lai`)
};

/**

* @param {Error_Irrigation_Run_Start_In_PastInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_run_start_in_past = /** @type {((inputs?: Error_Irrigation_Run_Start_In_PastInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Run_Start_In_PastInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_run_start_in_past(inputs)
});